import React from 'react';
import { Layout } from 'antd';

import { version } from '../../../../package.json';

const { Footer } = Layout;

export const FooterPortal = () => {
  return (
    <Footer>
      <p>My TaylorMade+ Admin Portal</p>
      <p>Version: {version}</p>
    </Footer>
  );
};
